import { request } from "services/api/util";

class ShiftService {
  getHeaders() {
    return {
      "Accept-Language": "th",
    };
  }

  async importFromS3Key(key) {
    return request({
      method: "post",
      url: "admin/shifts/import",
      data: { key },
      headers: this.getHeaders(),
    });
  }

  async exportShift(params) {
    const config = {
      method: "get",
      url: "admin/shifts/export",
      params: params,
      headers: this.getHeaders(),
    };
    return request(config);
  }
}

export default new ShiftService();
